<template>
  <el-row class="height-100 back-color pt-30 pr-30 pl-30 pb-20">
    <el-col class="top">
      <img class="width-100" :src="vipImg" />
      <span class="vip-btn" @click="toPay">
        {{ label }}
      </span>
    </el-col>
    <el-col class="bottom pt-30">
      <el-row class="pb-20">
        <span class="title">基础会员特权</span>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="8">
          <el-row class="item">
            <el-col>
              <img :src="img1" />
              <p>结算提交</p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row class="item">
            <el-col>
              <img :src="img2" />
              <p>付款申请</p>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row class="item">
            <el-col>
              <img :src="img3" />
              <p>对账查询</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import api from '@/http/pay/pay'
export default {
  data() {
    return {
      label: '立即开通',
      vipImg: require('@/assets/img/vipBack.jpg'),
      type: 0,
      img1: require('@/assets/img/vip_jiesuantijiao.png'),
      img2: require('@/assets/img/vip_fukuanshenqing.png'),
      img3: require('@/assets/img/vip_duizhangchaxun.png')
    }
  },
  mounted() {
    this.initList()
  },
  methods: {
    initList() {
      api.getProductList().then(res => {
        console.log('商品列表', res)
      })
    },
    toPay() {
      this.$router.push({ name: 'vipPay' })
    },
    checkType() {
      switch (this.type) {
        case 0:
          this.$message('微信支付')
          break
        case 1:
          this.$message('支付宝')
          break
        case 2:
          this.$message('银联')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  position: relative;
}
.bottom {
  .title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 240px;
    background: #f6f6f6;
    text-align: center;
    &::v-deep {
      .el-col {
        width: auto;
      }
    }
    img {
      width: 98px;
      height: 98px;
      margin: 0 auto;
    }
    p {
      font-size: 20px;
      text-align: center;
    }
  }
}
.vip-btn {
  position: absolute;
  bottom: 40px;
  left: 180px;
  display: inline-block;
  width: 120px;
  height: 40px;
  background: #ffe4ca;
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.type-title {
  font-size: 1.5rem;
}
::v-deep {
  .el-radio__label {
    font-size: 1.5rem;
  }
  .el-radio__inner {
    width: 1.75rem;
    height: 1.75rem;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: $primary;
    background: white;
  }
  .el-radio__inner::after {
    width: 1rem;
    height: 1rem;
    background: $primary;
  }
}
</style>
